export default "__VITE_ASSET__AEql7WwG__"